import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { FaRegTrashCan } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa";

function Congelation({ onClose, valorActual, actualizarTarifa, concepto }) {
  const [data, setData] = useState([]);
  const [cargoMinimo, setCargoMinimo] = useState("");

  // Cargar datos iniciales simulados
  useEffect(() => {
    if (valorActual) {
      setData(valorActual.tabla || []);
      setCargoMinimo(valorActual.cargoMinimo || "");
    }
  }, [valorActual]);

  const agregarFila = () => {
    const nuevaFila = { v1: "", v2: "", v3: "", activo: false };
    setData([...data, nuevaFila]);
  };

  const eliminarFila = (index) => {
    setData(data.filter((_, i) => i !== index));
  };

  const handleChange = (index, campo, valor) => {
    const nuevaData = [...data];
    nuevaData[index][campo] = valor;
    setData(nuevaData);
  };

  const validarCampos = () => {
    if (cargoMinimo === "") {
      return false;
    }

    return data.every(
      (fila) => fila.v1 !== "" && fila.v2 !== "" && fila.v3 !== "",
    );
  };

  const handleActualizar = () => {
    if (!validarCampos()) {
      Swal.fire({
        icon: "error",
        title: "Campos incompletos",
        text: "No se permiten filas con campos vacíos",
      });
      return;
    }

    actualizarTarifa(concepto, {
      tabla: data,
      cargoMinimo: cargoMinimo,
    });

    Swal.fire({
      title: "Éxito",
      text: "Almacenaje actualizado con éxito",
      icon: "success",
    }).then(() => {
      onClose();
    });
  };

  const bloquearTeclas = (e) => {
    const teclasPermitidas = [
      "Backspace",
      "Delete",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
    ];

    if (!/[0-9.]/.test(e.key) && !teclasPermitidas.includes(e.key)) {
      e.preventDefault();
    }
  };

  const limpiarInput = (e) => {
    let valor = e.target.value;

    valor = valor.replace(/[^0-9.]/g, "");

    const partes = valor.split(".");
    if (partes.length > 2) {
      valor = partes[0] + "." + partes.slice(1).join("");
    }

    if (valor !== e.target.value) {
      e.target.value = valor;
    }
  };

  return (
    <>
      {/* Aquí va la estructura específica */}
      <div className="container-fluid d-flex justify-content-center align-items-center">
        <div className="text-left">
          <div className="row mb-4">
            <label className="fw-bold d-block mb-2">CONGELACIÓN (MXN)</label>
          </div>

          <div className="row">
            <div className="table-responsive">
              <table className="table table-inverse table-hover table-striped table-bordered text-center">
                <thead>
                  <tr>
                    <th>De</th>
                    <th>A</th>
                    <th>Factor</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((fila, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          step="any"
                          onKeyDown={bloquearTeclas}
                          onInput={limpiarInput}
                          value={fila.v1}
                          onChange={(e) =>
                            handleChange(index, "v1", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          step="any"
                          onKeyDown={bloquearTeclas}
                          onInput={limpiarInput}
                          value={fila.v2}
                          onChange={(e) =>
                            handleChange(index, "v2", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          step="any"
                          onKeyDown={bloquearTeclas}
                          onInput={limpiarInput}
                          value={fila.v3}
                          onChange={(e) =>
                            handleChange(index, "v3", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <FaRegTrashCan
                          style={{ cursor: "pointer", color: "black" }}
                          onClick={() => eliminarFila(index)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="text-center mb-4">
                <button className="btnn" onClick={agregarFila}>
                  <FaPlus />
                </button>
              </div>
            </div>
          </div>

          {/* CARGO MINIMO */}
          <div className="row mb-4">
            <label className="fw-bold d-block mb-2">CARGO MÍNIMO:</label>

            <div className="d-flex align-items-center flex-wrap gap-2">
              <input
                type="number"
                className="form-control form-control-sm"
                style={{ width: "200px" }}
                step="any"
                onKeyDown={bloquearTeclas}
                onInput={limpiarInput}
                value={cargoMinimo}
                onChange={(e) => setCargoMinimo(e.target.value)}
              />
            </div>
          </div>

          <div className="d-flex justify-content-end">
            <button className="btnn" onClick={handleActualizar}>
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Congelation;
